import { useCallback, useState } from 'react'

import { RequestStatus } from 'core/domain/Request'

import { type SpotQuoteListItem } from '../domain/SpotQuoteListItem'
import { getSpotQuoteList } from '../use-cases/getSpotQuoteList'

const SPOT_QUOTE_LIST_LIMIT = 50

type State = {
  spotQuoteList?: Array<SpotQuoteListItem>
  spotQuoteListStatus: RequestStatus
}

const initialState = {
  spotQuoteListStatus: RequestStatus.Initial,
}

export function useSpotQuoteList() {
  const [{ spotQuoteList, spotQuoteListStatus }, setSpotQuoteListState] =
    useState<State>(initialState)

  const fetchSpotQuoteList = useCallback(async (abortController?: AbortController) => {
    try {
      setSpotQuoteListState(previous => ({
        ...previous,
        spotQuoteListStatus: RequestStatus.Pending,
      }))

      const spotQuoteResult = await getSpotQuoteList(
        { limit: SPOT_QUOTE_LIST_LIMIT },
        abortController
      )

      setSpotQuoteListState(previous => ({
        ...previous,
        spotQuoteList: spotQuoteResult,
        spotQuoteListStatus: RequestStatus.Done,
      }))
    } catch (error) {
      if (!abortController?.signal.aborted) {
        setSpotQuoteListState(previous => ({
          ...previous,
          spotQuoteListStatus: RequestStatus.Error,
        }))
      }
    }
  }, [])

  return {
    spotQuoteList,
    spotQuoteListStatus,
    fetchSpotQuoteList,
  }
}
